export function Svg({ size = 24, children, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    >
      {children}
    </svg>
  )
}

export function IconTarget(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      <path d="M12 1v3M12 20v3M1 12h3M20 12h3" />
    </Svg>
  )
}

export function IconPill(props) {
  return (
    <Svg {...props}>
      <rect x="3" y="9" width="18" height="6" rx="3" transform="rotate(-30 12 12)" />
      <path d="M9.5 7.5l7 7" />
    </Svg>
  )
}

export function IconShield(props) {
  return (
    <Svg {...props}>
      <path d="M12 2l8 3v7c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5l8-3z" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  )
}

export function IconProvider(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="8" r="3.5" />
      <path d="M5 21c0-3.5 3-6.5 7-6.5s7 3 7 6.5" />
      <path d="M16 14v2a3 3 0 006 0" />
      <circle cx="22" cy="16" r="1.2" fill="currentColor" />
    </Svg>
  )
}

export function IconSun(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="3.5" />
      <path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.5 4.5l1.5 1.5M18 18l1.5 1.5M4.5 19.5L6 18M18 6l1.5-1.5" />
    </Svg>
  )
}

export function IconChart(props) {
  return (
    <Svg {...props}>
      <rect x="2.5" y="4" width="19" height="13" rx="2" />
      <path d="M6 14l3-4 3 2 4-5 3 4" />
      <path d="M8 21h8M12 17v4" />
    </Svg>
  )
}

export function IconCheck(props) {
  return (
    <Svg {...props} strokeWidth="2.2">
      <path d="M5 12l4.5 4.5L19 7" />
    </Svg>
  )
}

export function IconClock(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </Svg>
  )
}

export function IconHeart(props) {
  return (
    <Svg {...props}>
      <path d="M12 20s-7-4.5-7-10a4.5 4.5 0 018-2.8A4.5 4.5 0 0119 10c0 5.5-7 10-7 10z" />
    </Svg>
  )
}

export function IconPulse(props) {
  return (
    <Svg {...props}>
      <path d="M2 12h5l2-5 4 10 2-5h7" />
    </Svg>
  )
}

export function IconShieldCheck(props) {
  return (
    <Svg {...props}>
      <path d="M12 2l8 3v7c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V5l8-3z" />
      <path d="M9 12l2 2 4-4" />
    </Svg>
  )
}

export function IconArrow(props) {
  return (
    <Svg {...props} strokeWidth="2">
      <path d="M5 12h14M13 6l6 6-6 6" />
    </Svg>
  )
}

export function IconStar({ size = 14 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2l3.1 6.3 6.9 1-5 4.9 1.2 6.8L12 17.8 5.8 21l1.2-6.8L2 9.3l6.9-1L12 2z" />
    </svg>
  )
}

/**
 * ✦ as an inline icon, sized to sit in text like the glyph did. None of the
 * site's fonts has ✦, so as text it sent the browser searching the system fonts
 * during the first layout — tens of ms on a mid-range phone, before first paint
 * and again when the web fonts swap in.
 */
export function IconSparkle({ size = '0.8em', style, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      style={{ display: 'inline', verticalAlign: '-0.05em', ...style }}
      {...rest}
    >
      <path d="M12 0l3.2 8.8L24 12l-8.8 3.2L12 24l-3.2-8.8L0 12l8.8-3.2z" />
    </svg>
  )
}

export function IconMenu(props) {
  return (
    <Svg {...props}>
      <path d="M3 6h18M3 12h18M3 18h18" />
    </Svg>
  )
}

export function IconX(props) {
  return (
    <Svg {...props}>
      <path d="M6 6l12 12M18 6L6 18" />
    </Svg>
  )
}

export function IconPlus(props) {
  return (
    <Svg {...props}>
      <path d="M12 5v14M5 12h14" />
    </Svg>
  )
}

export function IconScale(props) {
  return (
    <Svg {...props}>
      <path d="M12 3v18" />
      <path d="M5 7h14" />
      <path d="M3 7l4 6H3" />
      <path d="M21 7l-4 6h4" />
      <path d="M7 21h10" />
    </Svg>
  )
}

export function IconFlower(props) {
  return (
    <Svg {...props}>
      <circle cx="12" cy="12" r="2.5" />
      <circle cx="12" cy="6" r="2" />
      <circle cx="12" cy="18" r="2" />
      <circle cx="6" cy="12" r="2" />
      <circle cx="18" cy="12" r="2" />
    </Svg>
  )
}

export function IconBolt(props) {
  return (
    <Svg {...props}>
      <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
    </Svg>
  )
}

export function IconFlask(props) {
  return (
    <Svg {...props}>
      <path d="M10 2h4" />
      <path d="M10 2v6l-5 9a2 2 0 001.7 3h10.6a2 2 0 001.7-3l-5-9V2" />
      <path d="M8.5 14h7" />
    </Svg>
  )
}

export function IconHourglass(props) {
  return (
    <Svg {...props}>
      <path d="M6 3h12" />
      <path d="M6 21h12" />
      <path d="M8 3v4l4 5 4-5V3" />
      <path d="M8 21v-4l4-5 4 5v4" />
    </Svg>
  )
}

export function IconSparkles(props) {
  return (
    <Svg {...props}>
      <path d="M12 3l1.2 4.8L18 9l-4.8 1.2L12 15l-1.2-4.8L6 9l4.8-1.2L12 3z" />
      <path d="M19 14l.6 2.4L22 17l-2.4.6L19 20l-.6-2.4L16 17l2.4-.6L19 14z" />
    </Svg>
  )
}
